import { Injectable, inject } from '@angular/core';

import { OnAppInit } from '../bootstrap/bootstrapper.service';
import { ScrollbarEnableService } from './scrollbar-enable.service';

@Injectable()
export class DsIntegrationBootstrapService implements OnAppInit {
    private readonly scrollbarService = inject(ScrollbarEnableService);

    onAppInit() {
        this.scrollbarService.enable();
    }
}
